const reqStatuses = {
    "uploaded": "UPLOADED",
    "validationInProgress": "VALIDATION IN PROGRESS",
    "validationFailed": "VALIDATION FAILED",
    "validationSuccesswithErrors": "VALIDATION SUCCESSFUL WITH ERRORS",
    "validationSuccessful": "VALIDATION SUCCESSFUL",
    "submit": "SUBMITTED",
    "fulfilled": "PROCESSED",
    "fulfilledWithFailures": "PROCESSED WITH FAILURES",
    "timedOut": "TIMED OUT"
}

//we won't show the Fix Errors and Warnings link if the number of erroneous rows are more than erroneousRowsCountLimit
const erroneousRowsCountLimit = 500

//the records count upper limit for showing the Add-On link
const addOnLinkRecordsCountLimit = 60000

//the max total requests (other than canceled requests) per user is 1000
const requestsCountLimit = 1000

export default {
    reqStatuses, erroneousRowsCountLimit, addOnLinkRecordsCountLimit, requestsCountLimit
}
